/* Kashmeer — home sections behaviour */
(function () {
  'use strict';

  /* ---------- Reveal on scroll ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;

  function initReveal(root) {
    (root || document).querySelectorAll('.ksh-reveal:not(.is-in)').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('is-in');
    });
  }

  /* ---------- Category slider arrows (RTL aware) ---------- */
  function initCats(root) {
    (root || document).querySelectorAll('[data-ksh-cats]').forEach(function (wrap) {
      if (wrap.dataset.kshReady) return;
      wrap.dataset.kshReady = '1';
      var track = wrap.querySelector('.ksh-cats__track');
      wrap.querySelectorAll('[data-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = track.clientWidth * 0.8;
          // In RTL, "next" moves visually to the left (negative scrollLeft)
          var dir = btn.dataset.dir === 'next' ? -1 : 1;
          if (getComputedStyle(track).direction !== 'rtl') dir = -dir;
          track.scrollBy({ left: dir * step, behavior: 'smooth' });
        });
      });
    });
  }

  /* ---------- Toast ---------- */
  var toast;
  function showToast(html) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'ksh-toast ksh';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    toast.innerHTML = html;
    toast.classList.add('is-on');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-on'); }, 3800);
  }

  /* ---------- Add to cart (uses Ella side cart when available) ---------- */
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-ksh-add]');
    if (!btn) return;
    ev.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    var original = btn.innerHTML;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = btn.dataset.adding || '...';

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.kshAdd), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetch(root + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        var hasSidebar = document.getElementById('halo-cart-sidebar') && window.sharedFunctions && window.sharedFunctions.updateSidebarCart;
        if (hasSidebar) {
          window.sharedFunctions.updateSidebarCart(cart);
          document.body.classList.add('cart-sidebar-show');
        } else {
          showToast((btn.dataset.added || 'تمت الإضافة للسلة') + ' <a href="' + root + 'cart">' + (btn.dataset.viewCart || 'عرض السلة') + '</a>');
        }
      })
      .catch(function (err) {
        showToast((err && (err.description || err.message)) || 'حدث خطأ، حاولي مرة أخرى');
      })
      .finally(function () {
        btn.removeAttribute('aria-busy');
        btn.innerHTML = original;
      });
  });

  function init(root) { initReveal(root); initCats(root); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
